import { AgentStatus } from '@21k/shared';

export const STATUS_CONFIG: Record<
  AgentStatus,
  { label: string; color: string; dot: string }
> = {
  [AgentStatus.LIVE]: { label: 'Live', color: '#22c55e', dot: '●' },
  [AgentStatus.AWAY]: { label: 'Away', color: '#f59e0b', dot: '●' },
  [AgentStatus.ON_LEAVE]: { label: 'On Leave', color: '#ef4444', dot: '●' },
  [AgentStatus.OFFLINE]: { label: 'Offline', color: '#475569', dot: '●' },
};

export function normalizeAgentStatus(status: string | null | undefined): AgentStatus {
  if (status && Object.values(AgentStatus).includes(status as AgentStatus)) {
    return status as AgentStatus;
  }
  return AgentStatus.OFFLINE;
}

export function formatAgentStatusWarning(
  firstName: string,
  lastName: string,
  status: AgentStatus,
): string {
  const label = STATUS_CONFIG[status].label;
  return `${firstName} ${lastName} is currently ${label}. Are you sure?`;
}
